import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import ErrorPage from "../pages/errors/ErrorPage";
import HomePage from "../pages/home/HomePage";
import MilestonesCuestionario from "../pages/milestones/MilestonesCuestionario";
import ReportPage from "../pages/reports/ReportPage";
import GroupReportPage from "../pages/reports/GroupReportPage";
import GroupPage from "../pages/group/GroupPage";
import Navbar from "./NavBar";
import TopHeader from "./TopHeader";
import Footer from "./Footer";
import { BreadcrumbProvider } from "../context/BreadcrumbContext";
import { GroupsFilterProvider } from "../context/GroupsFilterContext";

const AppRouter = () => {
    return (
        <Router>
            <BreadcrumbProvider>
            <GroupsFilterProvider>
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <TopHeader />

                <div className="d-flex flex-grow-1 overflow-hidden">
                    <Navbar />
                    <div className="flex-grow-1" style={{overflow:'auto'}}>
                        <Switch>
                            <Route path="/" exact component={HomePage}></Route>
                            <Route path="/group" component={GroupPage}></Route>
                            <Route path="/reporte-progreso" component={ReportPage} exact></Route>
                            <Route path="/reporte-grupo" component={GroupReportPage} exact></Route>
                            <Route path="/hitos" component={MilestonesCuestionario} exact></Route>
                            <Route path="*" component={ErrorPage}></Route>
                        </Switch>
                    </div>
                </div>
                <Footer />

            </div>
            </GroupsFilterProvider>
            </BreadcrumbProvider>
        </Router>
    );
};

export default AppRouter;
